import React from "react";
import theme from "../data/theme";

// Standalone empty state for a direct /recap load. Draft recaps (the post-mock-
// draft results screen) are not persisted after a draft ends, so a fresh /recap
// load has nothing to show — point the visitor to run a mock draft. Display-
// only; the in-app post-draft recap (ResultsScreen in mock mode) is unchanged.
export default function DraftRecapEmpty({ onStartDraft }) {
  return (
    <div style={{
      minHeight: "100vh", background: theme.colors.bg.app,
      display: "flex", alignItems: "center", justifyContent: "center", padding: theme.spacing.xxxl,
    }}>
      <div style={{ maxWidth: 460, textAlign: "center" }}>
        <div style={{ fontSize: 44, marginBottom: theme.spacing.lg }} aria-hidden="true">📋</div>
        <h1 style={{
          fontFamily: theme.fonts.display, fontWeight: theme.fontWeight.black,
          fontSize: theme.fontSize.title, color: theme.colors.text.primary, margin: `0 0 ${theme.spacing.md}px`,
        }}>Your draft recap</h1>
        <p style={{
          fontFamily: theme.fonts.body, fontSize: theme.fontSize.body,
          color: theme.colors.text.muted, lineHeight: 1.5, margin: `0 0 ${theme.spacing.xxxl}px`,
        }}>Run a mock draft to get your recap — grades, best values, biggest reaches, and how your roster stacks up.</p>
        <button onClick={onStartDraft} style={{
          background: theme.colors.brand.gradientBtn, color: "#fff", border: "none",
          borderRadius: theme.radius.lg, padding: "12px 24px",
          fontFamily: theme.fonts.display, fontWeight: theme.fontWeight.bold,
          fontSize: theme.fontSize.sub, cursor: "pointer", letterSpacing: "0.5px",
          boxShadow: theme.helpers.brandGlow(0.25),
        }}>Start a mock draft →</button>
      </div>
    </div>
  );
}
